import { ThesisSubmissionExaminerStatus } from '@rdm/db'

import { AuthUser } from '../common.js'
import { EXAMINER_ASSIGNED_STATUSES, EXAMINER_REMOVED_STATUSES } from './examiners/thesisExaminerStatusScenarios.js'

/**
 * Checks if the current user is the assigned Principal Advisor of the thesis
 */
export const isAssignedThesisPrincipalAdvisor = (currentUser: AuthUser, userId: number) => {
  return currentUser.roles.includes('user-thesis-principal-advisor') && currentUser.id === userId
}

/**
 * Checks if the current user is the candidate of the thesis
 */
export const isAssignedThesisCandidate = (currentUser: AuthUser, userId: number) => {
  return currentUser.roles.includes('user-thesis-submission') && currentUser.id === userId
}

/**
 * Checks if the current user is the assigned chair of the thesis
 */
export const isAssignedThesisChair = (currentUser: AuthUser, userId: number) => {
  return currentUser.roles.includes('user-thesis-chair') && currentUser.id === userId
}

/**
 * Checks if the current user is an examiner that is in pending approval
 */
export const isPendingThesisExaminer = (
  currentUser: AuthUser,
  userId: number | null,
  status: ThesisSubmissionExaminerStatus,
) => {
  return (
    currentUser.roles.includes('user-thesis-examiner') &&
    currentUser.id === userId &&
    !EXAMINER_ASSIGNED_STATUSES.has(status) &&
    !EXAMINER_REMOVED_STATUSES.has(status)
  )
}

/**
 * Checks if the current user is an non-rejected or removed examiner of the thesis
 */
export const isActiveThesisExaminer = (
  currentUser: AuthUser,
  userId: number | null,
  status: ThesisSubmissionExaminerStatus,
) => {
  return (
    currentUser.roles.includes('user-thesis-examiner') &&
    currentUser.id === userId &&
    !EXAMINER_REMOVED_STATUSES.has(status)
  )
}

/**
 * Checks if the current user is an approved examiner of the thesis
 */
export const isAssignedThesisExaminer = (
  currentUser: AuthUser,
  userId: number,
  status: ThesisSubmissionExaminerStatus,
) => {
  return (
    currentUser.roles.includes('user-thesis-examiner') &&
    currentUser.id === userId &&
    EXAMINER_ASSIGNED_STATUSES.has(status)
  )
}

/**
 * Checks if the current user is a rejected examiner of the thesis
 */
export const isRejectedThesisExaminer = (
  currentUser: AuthUser,
  userId: number,
  status: ThesisSubmissionExaminerStatus,
) => {
  return (
    currentUser.roles.includes('user-thesis-examiner') &&
    currentUser.id === userId &&
    EXAMINER_REMOVED_STATUSES.has(status)
  )
}
